import * as React from "react";
import Avatar from "@mui/material/Avatar";

import { NavItems, NavItem, UserMenu, NavBar, Logo } from "./VANavBar.styles";
import valorLogo from "./valor-logo.png";

function VANavBar() {
  return (
    <NavBar style={{ display: "flex" }}>
      <Logo>
        <img src={valorLogo} alt="Valor Health" width="185" />
      </Logo>
      <NavItems>
        <NavItem className="selected">
          <a href="/member/list">Dashboard</a>
        </NavItem>
        <NavItem>
          <a href="/member/list">Patients</a>
        </NavItem>
        <NavItem>
          <a href="/member/list">Protocols</a>
        </NavItem>
        <NavItem>
          <a href="/member/list">Users</a>
        </NavItem>
        <NavItem>
          <a href="/member/list">Reports</a>
        </NavItem>
      </NavItems>
      <UserMenu>
        <Avatar sx={{ bgcolor: "#3874cb" }}>MV</Avatar>
      </UserMenu>
    </NavBar>
  );
}

export default VANavBar;
